export default function(){
	return {
		appPage:[
		{title:'首页',type:'index',body:[],candel:false,url:'slef://index'},
		{title:'预约',type:'sever',body:[{systemPage:true,page:"sever"}],candel:false,url:'slef://sever'},
		{title:'商品分类',type:'classify',body:[{systemPage:true,page:"goodsClassify"}],candel:false,url:'slef://classify'},
		{title:'购物车',type:'cart',body:[{systemPage:true,page:"cart"}],candel:false,url:'slef://cart'},
		{title:'我的',type:'my',body:[{systemPage:true,page:"my"}],candel:false,url:'slef://my'},
		{title:'新闻资讯',type:'news',body:[{systemPage:true,page:"newslist"}],candel:false,url:'slef://news'},
		{title:'名片列表',type:'card',body:[{systemPage:true,page:"cardlist"}],candel:false,url:'slef://card'},
		{title:'自定义页面',type:'page',body:[],candel:true,url:'slef://page1'},
		],
		widget:[
		{tagName:'导航', nav:['导航设置'], navOn:0, check:true,default:'#222',hover:'#44b549',bg:'#fff',useStyle:true, list:[ {title:'首页',type:'首页',icon:{type:'图片',src:'http://img.alicdn.com/tps/TB1ld1GNFXXXXXLapXXXXXXXXXX-200-200.png'},icon_on:{type:'图片',src:'http://img.alicdn.com/tps/TB1ld1GNFXXXXXLapXXXXXXXXXX-200-200.png'},url:'slef://index'}, {title:'我的',type:'个人中心',icon:{type:"图标",src:'g_my'},icon_on:{type:"图标",src:'g_my_on'},url:'slef://my'}, ] }
		],
		navigationBar:{tagName:"导航栏",nav:["导航栏"],navOn:0,bgColor:"#ffffff",userBg:"#ffffff",frontColor:"#000000"},
		severConfig:{tagName:'服务详情',nav:['服务详情设置'],navOn:0,btnAction:"确认订单",showShare:true,showPhone:true,phone:'000-000000',btn:'立即预约',btnAction:'默认'},
		newsConfig:{},
		cardConfig:{},
		myConfig:{},
		style:'rgb(222, 68, 58)',
		widgetOn:0,
		appPageon:0,
	}
}


// WEBPACK FOOTER //
// ./src/components/defaultConfig.js